// 森美兰州球场数据
// Negeri Sembilan Golf Courses

export const NEGERI_SEMBILAN_COURSES = {
  "GEMAS_GOLF_RESORT": {
    shortName: "GGR",
    fullName: "Gemas Golf Resort",
    location: ["Gemas", "Negeri Sembilan", "Malaysia"],
    pars: [4,4,5,3,4,4,5,3,4, 4,4,5,3,4,4,5,3,4],
    index: [9,5,3,17,11,7,1,13,15, 8,14,12,16,4,6,2,18,10]
  },

  "KELAB_REKREASI_ANGKATAN_TENTERA_NS": {
    shortName: "KRAT-NS",
    fullName: "Kelab Rekreasi Angkatan Tentera (Seremban)",
    location: ["Seremban", "Negeri Sembilan", "Malaysia"],
    pars: [4,5,3,4,3,4,5,4,4],
    index: [2,1,9,3,5,8,6,7,4]
  },

  "KOTA_SERIEMAS_GOLF_AND_COUNTRY_CLUB": {
    shortName: "KSGCC",
    fullName: "Kota Seriemas Golf & Country Club",
    location: ["Nilai", "Negeri Sembilan", "Malaysia"],
    pars: [5,4,4,4,4,3,5,3,4, 5,4,4,4,3,5,3,4,4],
    index: [11,1,3,13,9,17,5,15,7, 12,6,4,14,18,16,10,8,2]
  },

  "NILAI_SPRINGS_GOLF_AND_COUNTRY_CLUB_ISLAND_PINES": {
    shortName: "NSGCC-IP",
    fullName: "Nilai Springs Golf & Country Club (Island + Pines)",
    location: ["Nilai", "Negeri Sembilan", "Malaysia"],
    pars: [5,4,4,3,4,4,3,5,4, 4,5,3,4,5,4,4,3,4],
    index: [1,15,7,9,3,17,11,13,5, 10,18,16,4,14,12,2,18,6]
  },

  "NILAI_SPRINGS_GOLF_AND_COUNTRY_CLUB_MANGO_ISLAND": {
    shortName: "NSGCC-MI",
    fullName: "Nilai Springs Golf & Country Club (Mango + Island)",
    location: ["Nilai", "Negeri Sembilan", "Malaysia"],
    pars: [5,4,3,4,4,3,5,4,4, 5,4,4,3,4,4,3,5,4],
    index: [3,13,7,5,11,15,9,17,1, 2,16,8,10,4,18,12,14,6]
  },

  "NILAI_SPRINGS_GOLF_AND_COUNTRY_CLUB_MANGO_PINES": {
    shortName: "NSGCC-MP",
    fullName: "Nilai Springs Golf & Country Club (Mango + Pines)",
    location: ["Nilai", "Negeri Sembilan", "Malaysia"],
    pars: [5,4,3,4,4,3,5,4,4, 4,5,3,4,5,4,4,3,4],
    index: [3,13,7,5,11,15,9,17,1, 10,18,16,4,14,12,2,18,6]
  },

  "PORT_DICKSON_GOLF_AND_COUNTRY_CLUB": {
    shortName: "PDGCC",
    fullName: "Port Dickson Golf & Country Club",
    location: ["Port Dickson", "Negeri Sembilan", "Malaysia"],
    pars: [4,4,4,3,4,3,5,4,5, 5,4,5,3,4,4,4,3,4],
    index: [9,1,11,15,13,17,5,3,7, 6,18,2,14,12,8,4,16,10]
  },

  "DICKSON_BAY_GOLF_RESORT": {
    shortName: "DBGR",
    fullName: "Dickson Bay Golf Resort",
    location: ["Port Dickson", "Negeri Sembilan", "Malaysia"],
    pars: [4,5,3,4,4,5,4,3,4, 5,4,4,3,4,4,3,5,4],
    index: [17,3,9,5,1,7,11,15,13, 12,14,4,16,2,18,10,6,8]
  },

  "Royal_Seri_Menanti_Golf_Club": {
    shortName: "RSMGCC",
    fullName: "Royal Seri Menanti Golf Club",
    location: ["Kuala Pilah", "Negeri Sembilan", "Malaysia"],
    pars: [5,4,3,4,4,4,5,4,3, 5,3,4,4,4,4,3,4,5],
    index: [15,11,3,1,13,7,17,9,5, 2,18,4,16,12,8,14,6,10]
  },

  "ROYAL_SERI_MENANTI_GOLF_AND_COUNTRY_CLUB": {
    shortName: "RSMGCC",
    fullName: "Royal Seri Menanti Golf & Country Club",
    location: ["Kuala Pilah", "Negeri Sembilan", "Malaysia"],
    pars: [5,4,3,4,4,4,5,4,3, 5,3,4,4,4,4,3,4,5],
    index: [15,11,3,1,13,7,17,9,5, 2,18,4,16,12,8,14,6,10]
  },

  "SEREMBAN_INTERNATIONAL_GOLF_CLUB": {
    shortName: "SIGC",
    fullName: "Seremban International Golf Club",
    location: ["Seremban", "Negeri Sembilan", "Malaysia"],
    pars: [4,3,5,4,4,5,4,4,3, 4,5,3,4,4,3,4,4,5],
    index: [15,13,9,3,7,5,1,11,17, 2,12,8,16,6,18,4,14,10]
  },

  "STAFFIELD_COUNTRY_RESORT_SOUTHERN_NORTHERN": {
    shortName: "SCR-SN",
    fullName: "Staffield Country Resort (Southern + Northern)",
    location: ["Mantin", "Negeri Sembilan", "Malaysia"],
    pars: [5,3,4,4,4,5,4,3,4, 4,4,5,3,4,4,3,4,5],
    index: [5,17,9,13,15,7,11,3,1, 10,4,12,16,6,2,14,8,18]
  },

  "STAFFIELD_COUNTRY_RESORT_WESTERN_NORTHERN": {
    shortName: "SCR-WN",
    fullName: "Staffield Country Resort (Western + Northern)",
    location: ["Mantin", "Negeri Sembilan", "Malaysia"],
    pars: [5,4,4,4,5,3,4,3,4, 4,4,5,3,4,4,3,4,5],
    index: [14,16,8,2,6,10,12,18,4, 9,3,11,15,5,1,13,7,17]
  },

  "STAFFIELD_COUNTRY_RESORT_WESTERN_SOUTHERN": {
    shortName: "SCR-WS",
    fullName: "Staffield Country Resort (Western + Southern)",
    location: ["Mantin", "Negeri Sembilan", "Malaysia"],
    pars: [5,4,4,4,5,3,4,3,4, 5,3,4,4,4,5,4,3,4],
    index: [13,15,7,1,5,9,11,17,3, 6,18,10,14,16,8,12,4,2]
  }
};

export default NEGERI_SEMBILAN_COURSES;
